import { Map } from "ol";
import { Options } from "ol/layer/BaseVector";
import VectorLayer from "ol/layer/Vector";
import VectorSource, { Options as SourceOptions } from "ol/source/Vector";
import React from "react";

type UseVectorLayerProps = {
  map: Map | undefined;
  layerOptions?: Options;
  sourceOptions?: SourceOptions;
  forceUpdate?: boolean;
};

export const useVectorLayer = ({
  map,
  layerOptions,
  sourceOptions,
  forceUpdate,
}: UseVectorLayerProps) => {
  const LineLayerRef = React.useRef(
    new VectorLayer({
      source: new VectorSource({
        features: [],
        ...sourceOptions,
      }),
      zIndex: 105,
      ...layerOptions,
    }),
  );

  React.useEffect(() => {
    const lineLayer = LineLayerRef.current;
    if (!layerOptions?.style) return;
    lineLayer.setStyle(layerOptions?.style);
  }, [layerOptions]);
  React.useEffect(() => {
    if (!map) return;

    const lineLayer = LineLayerRef.current;
    map.addLayer(lineLayer);

    // eslint-disable-next-line consistent-return
    return () => {
      map.removeLayer(lineLayer);
    };
  }, [map, forceUpdate]);

  const layerSource = LineLayerRef.current.getSource();

  return { vectorLayer: LineLayerRef.current, layerSource };
};
